import { render, staticRenderFns } from "./addPeriodMaint.vue?vue&type=template&id=a2201182"
import script from "./addPeriodMaint.vue?vue&type=script&lang=js"
export * from "./addPeriodMaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports